module.exports = require("../lib/hooks/useStableMemo");